import { FaSearch } from 'react-icons/fa';
import styled from 'styled-components';

export const TextMainDiv = styled.div`
    flex-wrap: wrap;
    flex-grow: 1;
    display: flex;
    gap: 10px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}
`;

export const ScrollableDiv = styled.div`
  height: 202px;
  overflow-y: auto;
  min-width: 505px;
  padding-right: 5px;
  overflow-x: hidden; /* Hides horizontal scroll */
  flex-wrap: wrap;
  flex-grow: 1;
  display: flex;
  gap: 10px;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`;

export const MainWrapper = styled.div`

padding: 15px;
border: 1px solid rgba(162, 162, 162, 1);
border-radius: 15px;
}
`;
export const FlexRowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const SearchMainDiv = styled.div`
  height: 55px;
  background: rgb(240, 255, 240);
  margin-top: 13px;
  margin-bottom: 25px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  display: grid;
  grid-template-columns: 1fr 50px;
  padding: 15px;
`;
export const SearchTopicsHeading = styled.h6`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-transform: capitalize;
  color: ${(props) =>
    props.color ? ' rgba(99, 99, 99, 0.7)' : 'rgba(0, 0, 0, 1)'};
  margin: 0px;
`;
export const RadioBtnDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
`;
export const RadioDiv = styled.div`
  font-weight:400;
  color: rgba(99, 99, 99, 0.7);
  font-size:14px;
  
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}
  /* Custom radio button styling */
  & > input[type="radio"] {
    display: none; /* Hide the default radio button */
  }

  /* Custom radio button */
  // & > input[type="radio"] + span {
  //   position: relative;
  //   // padding-left: 25px; /* Space for custom radio button */
  //   cursor: pointer;
  //   width:5px;
  //   height:5px;
  //   position: relative; /* To position the checkmark */
  //   cursor: pointer;
  //   display: block;
  //   user-select: none;
  // }

  // & > input[type="radio"] + span::before {
  //   content: '';
  //   position: absolute;
  //   left: 0.5px;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background-color: white;
  //   border: 2px solid rgba(99, 99, 99, 0.7); /* Default border color */
  // }
     & input[type='radio'] + span {
    appearance: none; /* Remove the default appearance of the radio button */
    width: 11px; /* Adjust size of the radio button */
    height: 11px;
    border: 1px solid rgb(112 112 112); /* Border color */
    border-radius: 50%; /* Round the edges */
    background-color: white; /* Default background color */
    position: relative; /* To position the checkmark */
    cursor: pointer; /* Make it clickable */
    transition: all 0.3s ease; /* Smooth transition for hover/focus */
  }
& input[type='radio']:checked+ span {
    background: linear-gradient(180deg, #2d8955 0%, #5eab41 100%);
    border-color: green; /* Green border when checked */
  }
  /* Change color of radio button when checked */
  & > input[type="radio"]:checked + span::before {
    background-color: white; /* Green when checked */
    border-color: green; /* Green border when checked */
  }

  /* Optional: Add a dot inside the radio button when checked */
  & > input[type="radio"]:checked + span::after {
    // content: '';
    // position: absolute;
    // top: 50%;
    // transform: translateY(-50%);
    // width: 8px;
    // height: 7px;
    // border-radius: 50%;
    background-color: green; /* White dot when checked */
    border-color: green; /* Green border when checked */
    // position: absolute;
    // transform: translateX(29%) translateY(-50%);
  }
`;

export const RecentlyCreated = styled.h6`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  text-transform: capitalize;
  color: rgba(99, 99, 99, 0.7);
  margin: 0px;
  margin-bottom: 12px;
  margin-top: 15px;
`;

export const DateVal = styled.div`
  font-size: 15px;
  font-weight: 300;
  font-family: Inter;
  margin: 10px 0px;
  text-align: center;
`;

export const TextDivTopic2 = styled.div`
  height: 90px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: ${(props) =>
    props?.topic
      ? 'linear-gradient(180deg, rgba(13, 115, 98, 0.7) 0%, rgba(77, 159, 71, 0.7) 100%)'
      : 'rgb(240, 255, 240)'};
  box-shadow: 0px 4px 4px 0px rgba(14, 88, 152, 0.25);
  flex-direction: column;
  gap: 10px;
  // cursor:pointer;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  border: ${(props) => (props?.topic ? '' : '1px solid rgba(0, 0, 0, 1)')};
  & > p {
    // height: 76px;
    width: 138px; /* Fixed height */
    // line-height: 76px;              /* Centers text vertically */
    text-align: center; /* Centers text horizontally */
    overflow: hidden; /* Clips overflowed text */
    white-space: nowrap; /* Prevents text from wrapping */
    text-overflow: ellipsis; /* Adds ellipsis (…) for overflow */
    padding: 0px;
    color: white;
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    margin: 0px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const LogoDiv = styled.div`
  & svg {
    width: 30px;
    height: ${(props) => (props?.channel ? '22px' : '')};
  }
`;

export const TextDivTopic = styled.div`
  height: 90px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: linear-gradient(
    180deg,
    rgba(13, 115, 98, 0.7) 0%,
    rgba(77, 159, 71, 0.7) 100%
  );
  box-shadow: 0px 4px 4px 0px rgba(14, 88, 152, 0.25);
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  & > p {
    // height: 76px;
    width: 138px; /* Fixed height */
    // line-height: 76px;              /* Centers text vertically */
    text-align: center; /* Centers text horizontally */
    overflow: hidden; /* Clips overflowed text */
    white-space: nowrap; /* Prevents text from wrapping */
    text-overflow: ellipsis; /* Adds ellipsis (…) for overflow */
    padding: 0px;
    color: white;
    font-family: Inter;
    font-weight: 600;
    font-size: 14px;
    margin: 0px;

    padding-right: 10px;
    padding-left: 10px;
  }
`;

export const AddIconDiv = styled.div`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  min-width: 380px;
  width: 100%;
  display: flex;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 5px 40px 5px 18px;
  border: none;
  border-radius: 20px;
  font-size: 16px;
  outline: none;

  height: 30px;
  &:focus {
    border: 1px solid green;
  }
`;

export const SearchIcon = styled(FaSearch)`
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
  pointer-events: none;
`;

export const SelectTopicWrapper = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;

  display: grid;
  grid-template-columns: 1fr 1fr;
`;

export const ShowTopicWrapper = styled.div`
  height: 270px;
  width: 85%;
  margin-left: auto;
  margin-right: auto; 
  border: 1px solid rgba(162, 162, 162, 1);
  border-radius: 20px;

  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 30px 0px;
  margin-left: auto;
  margin-right: auto;
  }

`;
export const TopicWrapper = styled.div`
  width: 190px;
  position: relative;

  &:hover .cross-icon {
    display: block;
  }
`;

export const CrossIconDiv = styled.div`
  display: none;
  position: absolute;
  right: 0px;
  top: 17%;
  cursor: pointer;
  z-index: 2;
`;

export const TitleSelected = styled.div`
  text-align: center;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Inter';
`;

export const SelectedChannelDiv = styled.div`
  padding: 20px;
  width: 180px;
  background: rgb(240, 255, 240);
  margin-left: -15px;
`;

export const DateFilterSharedDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 13px;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 13px;
  }

  & > :nth-child(1) {
    justify-content: end;
  }
  & > :nth-child(2) {
    justify-content: flex-start;
  }
`;
export const DateFilterDiv = styled.div`
  display: grid;
  grid-template-columns: 100px 1fr 1fr;
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  gap: 15px;

  & > :nth-child(2),
  & > :nth-child(3) {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    justify-content: space-between;
  }

  & > :nth-child(1) {
    display: flex;
    align-items: end;

    width: 100%;
    justify-content: end;
    & > div {
      text-align: center; /* Centers text horizontally */
      overflow: hidden; /* Clips overflowed text */
      white-space: nowrap; /* Prevents text from wrapping */
      text-overflow: ellipsis; /* Adds ellipsis (…) for overflow */
      padding: 0px;
      color: rgba(99, 99, 99, 0.7);
      font-family: Inter;
      font-weight: 600;
      font-size: 14px;
      margin: 0px;
      height: 28px;
      align-items: center;
      vertical-align: middle;
    }
  }
`;

export const DateFilterSubWrapper = styled.div`
  border: 1px solid rgba(162, 162, 162, 1);
  border-radius: 20px;
  padding: 20px;
  margin-top: 15px;
  & > div:first-child {
    display: grid;
    grid-template-columns: 1fr 1fr;
    // margin-bottom: 30px;
  }
`;
